type StatusBadgeProps = {
  status: string;
  customColors?: Record<string, string>;
  className?: string;
};

/**
 * Generic status badge component that can be used across different features
 * The component automatically applies appropriate styling based on the status
 * Custom colors can be provided to override the default color scheme
 */
const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  customColors = {},
  className = "",
}) => {
  const getStatusColor = () => {
    // Default color mappings
    const defaultColors: Record<string, string> = {
      active: "bg-green-500 text-white",
      upcoming: "bg-blue-500 text-white",
      expired: "bg-gray-500 text-white",
      pending: "bg-yellow-500 text-white",
      completed: "bg-purple-500 text-white",
      deleted: "bg-red-500 text-white",
    };

    // Use custom color if provided, otherwise fall back to default
    const colorMap = { ...defaultColors, ...customColors };

    return colorMap[status.toLowerCase()] || "bg-gray-300 text-gray-700";
  };

  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${getStatusColor()} ${className}`}
    >
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
};

export default StatusBadge;
